import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { Card, Grid, Header, Segment } from "semantic-ui-react";
import { ScrollableGrid } from "../../styles/ScrollableGrid";
import Steps from "./Steps";

function ImportsTable({ rows }) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return (
      <Segment basic>
        <Header as="h3" textAlign="center">
          No results
        </Header>
      </Segment>
    );
  }
  return (
    <div style={ScrollableGrid}>
      <Grid padded>
        <Grid.Row verticalAlign="middle">
          <Grid.Column width={3}>
            <Card.Meta>Imported file</Card.Meta>
          </Grid.Column>
          <Grid.Column width={3}>
            <Card.Meta>Last executed</Card.Meta>
          </Grid.Column>
          <Grid.Column width={5} />
          <Grid.Column textAlign="right" width={5}>
            <Card.Meta>Steps</Card.Meta>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {rows.map((row) => (
        <Link key={row.id} to={"/maintenance/flight-schedules-import/" + row.id}>
          <Card fluid>
            <Card.Content>
              <Grid>
                <Grid.Row verticalAlign="middle">
                  <Grid.Column width={3}>
                    <Card.Header>{row.filename}</Card.Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Card.Meta>{moment(row.updatedAt).format("DD/MM/YYYY LT")}</Card.Meta>
                  </Grid.Column>
                  <Grid.Column width={4} />
                  <Grid.Column textAlign="right" width={6}>
                    <Steps align="right" step={row.executionStatus} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Card.Content>
          </Card>
        </Link>
      ))}
    </div>
  );
}

export default ImportsTable;



// WEBPACK FOOTER //
// ./src/component/Maintenance/ImportFlights/ImportsTable.js